import React from "react"

import Studio from "features/studio/Studio"
import WithApps from "data/wrappers/WithApps"
import PageTitle from "ui/components/PageTitle"
import Container from "ui/components/Container"
import Section from "ui/components/Section"
import Breadcrumbs from "ui/components/Breadcrumbs"
import AppTable from "features/studio/components/AppTable"

export default class AppListPage extends React.Component {
    render() {
        return (
            <Studio color="yellow">
                <Container marginBottom="medium" spaced>
                    <Section margin="none" padding="none">
                        <Breadcrumbs crumbs={[{ label: "Apps" }]} />
                        <PageTitle>Apps</PageTitle>
                    </Section>
                </Container>
                <WithApps>
                    {({ apps, onChange }) => <AppTable onChange={onChange} data={apps} />}
                </WithApps>
            </Studio>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/studio/containers/AppListPage.js